import React from 'react'
import { Paper, Table, TableHead, TableContainer, TableCell, TableRow } from '@mui/material'
import Loading from '../../../components/Common/Loading'
import { RubroPosible } from '../../Integraciones/types/responses-productos'

interface Props {
  rubros: RubroPosible[]
  loading: boolean
  isMobile: boolean
}

const PosiblesRubros: React.FC<Props> = ({ rubros, loading, isMobile }) => {
  if (loading) return <Loading />
  return (
    <>
      <TableContainer
        component={Paper}
        style={{
          margin: isMobile ? '10px' : '10px 30px',
          border: '1px solid grey',
          maxWidth: '95%'
        }}
      >
        <Table
          sx={{
            tableLayout: 'initial'
          }}
        >
          <TableHead
            aria-label="Rubros"
            sx={{
              fontWeight: 'bold',
              backgroundColor: '#e0e0e0',
              color: 'white'
            }}
          >
            <TableRow>
              <TableCell sx={{ textAlign: 'center', fontWeight: 'bold' }}>Rubro (código)</TableCell>
              <TableCell sx={{ textAlign: 'center', fontWeight: 'bold' }}>Probabilidad (%)</TableCell>
            </TableRow>
          </TableHead>
          {rubros.map((rubro: RubroPosible, i: number) => (
            <TableRow key={rubro.codRubro}>
              <TableCell
                style={{ width: '50%', textAlign: 'center' }}
              >{`${rubro.category} (${rubro.codRubro})`}</TableCell>
              <TableCell style={{ width: '50%', textAlign: 'center' }}>
                {Number(rubro.probability).toFixed(3)}
              </TableCell>
            </TableRow>
          ))}
        </Table>
      </TableContainer>
    </>
  )
}

export default PosiblesRubros
